import { PossibleBusinessObject } from '../types'
import { UserAttributeDefs } from '../types/ModelTypes'
import { ModelCommon } from './ModelCommon'

import { type BooleanRuleType } from '../ModelClassInterfaces/Ruleset'

const debug = !process.env.AWS_SESSION_TOKEN && false

const typeName = 'BooleanRule'

class BooleanRule extends ModelCommon implements BooleanRuleType {
  constructor(ob: PossibleBusinessObject & Partial<BooleanRuleType>) {
    super(typeName, ob)

    if (ob) {
      const userAttDefs = this.getUserAttributes()
      Object.entries(userAttDefs).forEach(([key, def]) => {
        if (Object.getOwnPropertyDescriptor(def, 'default') && ob[key] === undefined) {
          this[key] = (def as { type: string; default: string }).default
        }
      })

      Object.assign(this, ob)
      debug && console.log('Tried to initialize metric rule', this)
    }
  }

  name = ''
  enabled: boolean = false
  triggeringValue: boolean = false

  get deviceEnabledType() {
    return this._deviceEnabledType
  }

  set deviceEnabledType(type) {
    this._deviceEnabledType = type
  }

  get key() {
    return this._key
  }

  set key(metric) {
    this._key = metric
  }

  isSaveable() {
    return false
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      name: { type: 'String' },
      description: { type: 'String' },
      enabled: { type: 'Boolean', default: false },
      triggeringValue: { type: 'Boolean', default: false },
      key: {
        type: 'String',
        label: 'Measurement',
      },
    }
  }
}

export { BooleanRule }
